import moment from "moment";
import {mapWritableState} from "pinia";
import useStore from "../store";


const getCardType = (cardNumber) => {

  let first = cardNumber.charAt(0);

  switch (first){
    case '3':
      return 'AMEX';
    case '4':
      return 'VISA';
    case '5':
      return 'MASTERCARD';
  }

  return '';
}

const debounce = (mainFunction, delay) => {
  // Declare a variable called 'timer' to store the timer ID
  let timer;

  // Return an anonymous function that takes in any number of arguments
  return (...args) => {
    // Clear the previous timer to prevent the execution of 'mainFunction'
    console.log(timer)
    clearTimeout(timer);

    // Set a new timer that will execute 'mainFunction' after the specified delay
    timer = setTimeout(() => {
      mainFunction(...args);
    }, delay);
  };
};


/* eslint-disable max-len */
const creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15})$/;
//var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

const isCreditCard = (str) => {
  let sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  let sum = 0;
  let digit;
  let tmpNum;
  let shouldDouble;

  for (let i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

const generateRandomString = (length, prefix = '') => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return prefix + result;
}



const convertToIcsDate = (date) => {
  return moment(date).format('YYYYMMDDTHHmmss');
}

const makeGoogleCalendarUrl = (date, summary, description = '') => {
  const start = convertToIcsDate(date.start);
  const end = convertToIcsDate(date.end);

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(summary)}&dates=${start}/${end}&details=${encodeURIComponent(description)}&ctz=Australia/Perth`;
}

const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
}

const isEnabledFlag = (value) => {
  if (typeof value === "boolean") {
    return value;
  }

  return ["1", "true", "yes", "on"].includes(String(value ?? "").trim().toLowerCase());
}

const resolveAttraction = (item) => {
  if (!item) {
    return null;
  }

  const store = useStore()



  if (item.attraction) {
    return store.attractions.find((current) => current?.id === item.attraction) ?? null;
  }

  if (item.productCode) {
    return store.attractions.find(
        (current) => current?.rezdy_retail_product_code === item.productCode
    ) ?? null;
  }

  return null;
};


const bookingItemsAreTooClose = (items = []) => {
  if (!Array.isArray(items) || items.length < 2) {
    return false;
  }


  const resolveTime = (item) =>
    item?.time ?? item?.startTimeLocal ?? item?.startTime ?? null;

  for (const item of items) {
    const itemTime = resolveTime(item);
    const currentAttraction = resolveAttraction(item);

    if (!itemTime || !currentAttraction?.distance || currentAttraction.distance.length < 1) {
      continue;
    }

    for (const compareItem of items.filter((current) => {
      return resolveAttraction(current)?.id !== resolveAttraction(item)?.id;
    })) {
      const compareTime = resolveTime(compareItem);
      const compareAttraction = resolveAttraction(compareItem);

      if (!compareTime || !compareAttraction?.id) {
        continue;
      }

      const compareAttractionDistance = currentAttraction.distance.find(
        (distance) => distance?.attraction === compareAttraction.id
      );

      if (
        compareAttractionDistance?.hours &&
        parseFloat(compareAttractionDistance.hours) === 0
      ) {
        continue;
      }

      const hours = parseFloat(compareAttractionDistance?.hours ?? 1);
      const from = moment(itemTime).subtract(hours, "hours");
      const to = moment(itemTime).add(hours, "hours");

      if (moment(compareTime).isBetween(from, to)) {
        return true;
      }
    }
  }

  return false;
}

const makeIcsFile = (date, summary, description = '') => {
  const value =
      "BEGIN:VCALENDAR\n" +
      "CALSCALE:GREGORIAN\n" +
      "METHOD:PUBLISH\n" +
      "PRODID:-//Test Cal//EN\n" +
      "VERSION:2.0\n" +
      "BEGIN:VEVENT\n" +
      "UID:test-1\n" +
      "DTSTART;TZID=Australia/Perth:" +
      convertToIcsDate(date.start) +
      "\n" +
      "DTEND;TZID=Australia/Perth:" +
      convertToIcsDate(date.end) +
      "\n" +
      "SUMMARY:" +
      summary +
      "\n" +
      "DESCRIPTION:" +
      description +
      "\n" +
      "END:VEVENT\n" +
      "END:VCALENDAR";


  const blob = new Blob([value], { type: "text/calendar;charset=utf-8" });

  const a = document.createElement('a');
  a.setAttribute('download', 'booking.ics');
  a.setAttribute('href', window.URL.createObjectURL(blob));
  a.click(); // EXECUTING CLICK EVENT WILL AUTO-DOWNLOAD THE FILE
}


const currentAttraction = (attraction) => {

  const store = useStore()

  if (!attraction){
    return false;
  }

  return store.attractions.find(a => a.id === this.item.attraction) ?? false
}

const trackBookingComplete = (booking) => {
    let items = booking.items.map((i) => {
      return {
        id: i.productCode,
        sku: i.productCode,
        name: i.productName.replaceAll(" ", ""),
        price: i.subtotal,
        quantity: i.totalQuantity,
      };
    });

    if (window?.fathom && booking?.totalAmount) {
      console.log('booking-complete', (booking.totalAmount * 100))
      window.fathom.trackEvent('booking-complete', {
        _value: (booking.totalAmount * 100), // Value is in cents
      });
    }

    if (window?.dataLayer){
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: booking.orderNumber,
          affiliation: "Checkout",
          value: parseFloat(booking.totalAmount.toFixed(2)),
          currency: "AUD",
          tax: 0,
          shipping: 0,
          items: items
        }
      });
    }
}

export {
  getCardType,
  debounce,
  isCreditCard,
  generateRandomString,
  makeIcsFile,
  makeGoogleCalendarUrl,
  isAndroid,
  isEnabledFlag,
  bookingItemsAreTooClose,
  currentAttraction,
  trackBookingComplete,
}
